import React from "react";
import { message, Tabs } from "antd";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { del, get } from "../../services";
import {
  UnorderedListOutlined,
  ProductOutlined,
  FunnelPlotFilled,
} from "@ant-design/icons";
import Cards from "./cards";
import Table from "./table";
import FilterModal from "./filter-modal";

const Faq = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [searchedFilter, setSearchFilter] = useState("");
  const [properties, setProperties] = useState([]);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);

  //method for API call
  const getPropertyHandler = (currentPage) => {
    setCurrentPage(currentPage);
    setLoader(true);
    // Remove ?find=
    const cleaned = location.search;
    // Convert to URLSearchParams
    const params = new URLSearchParams(cleaned);
    const filterParams = [];
    params.forEach((value, key) => {
      filterParams.push(`${key}=${value}`);
    });
    // Final result
    const finalQuery = filterParams.join("&");
    const search = finalQuery ? "&" + finalQuery : "";
    setSearchFilter(search);
    get(
      `/property?page=${currentPage}&limit=${limit}${search}&publishing_status=UNPUBLISHED`
    )
      .then((response) => {
        setProperties(response?.data);
        setLoader(false);
      })
      .catch((error) => {
        message.error("Error", error?.response?.data?.message);
        setLoader(false);
      });
  };

  //  API For Faq
  useEffect(() => {
    getPropertyHandler(1);
    // eslint-disable-next-line
  }, [limit, location.search]);

  // confirm handler
  const confirm = (data) => {
    setSelectedRecord(data?._id);
    del(`/property/${data?._id}`)
      .then(() => {
        // to delete locally from our database
        const remaingRecords = properties?.properties?.filter(
          (item) => item?._id !== data?._id
        );
        setProperties({ ...properties, properties: remaingRecords });
        // success message
        message.success("Record deleted Successfully");
        setSelectedRecord(false);
      })
      .catch((error) => {
        message.error("Error", error?.response?.data?.message);
        setSelectedRecord(false);
      });
  };

  const cancel = (e) => {
    console.log(e);
  };

  // filter Data
  const handleFilter = (values) => {
    const filterParams = Object.entries(values)
      .filter(([_, value]) => value && value !== "")
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");
    const queryString = `&${filterParams}`;
    navigate(`/unpublished-properties?${queryString}`);
    setIsFilterModalOpen(false);
  };
  return (
    <React.Fragment>
      <div className="header mb-5">
        <h3>Properties</h3>
        <div className="d-flex">
          <button
            className="cursor-pointer "
            onClick={() => setIsFilterModalOpen(true)}
          >
            <span className="mx-5">
              <FunnelPlotFilled />
            </span>
            Filter
          </button>
          {searchedFilter && (
            <button
              className="cursor-pointer ml-5 filter-clear-button"
              onClick={() => navigate(`/unpublished-properties`)}
            >
              Clear
            </button>
          )}
        </div>
      </div>
      {/* Modal */}
      <FilterModal
        isFilterModalOpen={isFilterModalOpen}
        setIsFilterModalOpen={setIsFilterModalOpen}
        handleFilter={handleFilter}
      />
      {/* Tabs */}
      <div>
        <Tabs
          defaultActiveKey="2"
          className="tab-container px-4"
          items={[
            {
              label: "",
              key: "1",
              children: (
                <Cards
                  confirm={confirm}
                  properties={properties}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  loader={loader}
                  selectedRecord={selectedRecord}
                  navigate={navigate}
                  getPropertyHandler={getPropertyHandler}
                  cancel={cancel}
                  limit={limit}
                  setLimit={setLimit}
                />
              ),
              icon: <ProductOutlined />,
            },
            {
              label: "",
              key: "2",
              children: (
                <Table
                  confirm={confirm}
                  properties={properties}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  loader={loader}
                  selectedRecord={selectedRecord}
                  navigate={navigate}
                  getPropertyHandler={getPropertyHandler}
                  cancel={cancel}
                  limit={limit}
                  setLimit={setLimit}
                  // rowSelection={rowSelection}
                />
              ),
              icon: <UnorderedListOutlined />,
            },
          ]}
        />
      </div>
    </React.Fragment>
  );
};
export default Faq;
